import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

/** A name validator that disallows numbers, special characters, and leading/trailing spaces */
export function nameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const numbersRegex = /\d/; // Regular expression to detect numbers
        const specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>]/;

        const value = control.value || ""; // In case control.value is null or undefined
        const containsNumbers = numbersRegex.test(value);
        const containsSpecialCharacters = specialCharacterRegex.test(value);

        return containsNumbers || containsSpecialCharacters ? { forbiddenName: { value: control.value } } : null;
    };
}
